import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Currency} from "../../currency-format/currency-format.typings";
import { CustomValidators } from 'ngx-custom-validators';
import {CountryInterface} from "../../../../interfaces/country.interface";


@Component({
  selector: 'app-currency-form',
  templateUrl: './currency-form.component.html',
  styleUrls: ['./currency-form.component.scss']
})
export class CurrencyFormComponent implements OnInit {

  POSITIONS = [{ value: "AFTER" }, { value: "BEFORE" }]
  SEPARATORS = [{ value: ",", text: "Comma (,)" }, { value: ".", text: "Dot (.)" }]
  filteredPositions = this.POSITIONS.slice();
  filteredSeparators = this.SEPARATORS.slice();

  @Output() validCurrency: EventEmitter<Currency | boolean> = new EventEmitter();
  @Input() currency: Currency;
  @Input() countries: CountryInterface[];
  mensajesError = {
    tipoValor: [],
    tiempo: [],
  };
  currencyForm: FormGroup;
  filteredCountries: CountryInterface[];
  subscribers = [];
  errorSeparators:string;
  currencyPreview:Currency = {
    "_id": "61227d5453e7b5000940263e",
    "countryCode": "ECU",
    "languageIsoCode": "es",
    "currencyCode": "USD",
    "format": {
      "useCode": true,
      "cents": 2,
      "currencyPosition": "BEFORE",
      "thousandIdentifier": ",",
      "decimalSeparator": "."
    },
    "createdAt": "2021-08-22T16:37:40.948Z"
  };
  constructor(
      private readonly _formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.setFormValues();
    this.currencyForm.valueChanges.subscribe(formValue => {
      this.currencyPreview = this.createCurrencyStructure();
    });
    this.filteredCountries = this.countries.slice();
  }
  initForm() {
    this._startForm();
    this._verifiedFieldsForm();
    this._verifiedform();
  }
  _startForm() {
    this.currencyForm = this._formBuilder.group({
      country: [null, [Validators.required]],//"US",
      languageIsoCode: "es",
      useCode: [false],
      cents: [0, [CustomValidators.range([0, 4])]],
      currencyPosition: [null, [Validators.required]],
      thousandIdentifier: [null, [Validators.required]],
      decimalSeparator: [null, [Validators.required]],
    });
  }
  _verifiedFieldsForm() {

  }
  _verifiedform() {
    const formularioFormGroup = this.currencyForm;
    const subscriber = formularioFormGroup
        .valueChanges
        .subscribe(
            formulario => {
              const noticiaValidada = formularioFormGroup.valid;
              if (noticiaValidada) {
                // formulario.nivelJuego = this.setearValorSelect(formulario.nivelJuego);
                // formulario.tipo = this.setearValorSelect(formulario.tipo);
                this.validCurrency.emit(this.createCurrencyStructure());
              } else {
                this.validCurrency.emit(false);
              }
            }
        );
    this.subscribers.push(subscriber);
  }
  removeErrorsSeparators(){
    this.currencyForm.controls['decimalSeparator'].setErrors(null);
    this.currencyForm.controls['thousandIdentifier'].setErrors(null);
  }

  changeThousandIdentifier($event){
    if($event.value == this.currencyForm.value.decimalSeparator){
      this.currencyForm.controls['thousandIdentifier'].setErrors({'incorrect': true});
      this.errorSeparators = "Thousand identifier can't be the same as the Decimal separator"
    }else {
      this.removeErrorsSeparators();
      this.errorSeparators ="Your selection is invalid"
    }
  }

  changeDecimalSeparator($event){
    if($event.value == this.currencyForm.value.thousandIdentifier){
      this.currencyForm.controls['decimalSeparator'].setErrors({'incorrect': true});
      this.errorSeparators = "Decimal separator can't be the same as the thousand identifier"
    }else {
      this.removeErrorsSeparators();
      this.errorSeparators ="Your selection is invalid"
    }
  }
  setFormValues() {
    if (this.currency) {
      let currency: any = { ...this.currency.format }
      currency['country'] = this.findCountry();
      currency['languageIsoCode'] = this.currency.languageIsoCode;
      this.currencyForm.setValue(currency);
      this.currencyPreview = {...this.currency}
    }
  }



  findCountry() {
    return this.countries.filter(item => item.countryCode == this.currency.countryCode)[0];
  }

  createCurrencyStructure(){
    let format = { ...this.currencyForm.value };
    delete format.languageIsoCode;
    delete format.country;

    let clonecurrency = {...this.currency}

    if (clonecurrency) {
      clonecurrency.format = format;
      clonecurrency.countryCode = this.currencyForm.value.country.countryCode;
      clonecurrency.currencyCode = this.currencyForm.value.country.currencyCode;
      clonecurrency.languageIsoCode = "es";
      return clonecurrency;
    } else {
      let newCurrency: any = {};
      newCurrency['format'] = format;
      newCurrency['countryCode'] = this.currencyForm.value.country.countryCode;
      newCurrency['currencyCode'] = this.currencyForm.value.country.currencyCode;
      newCurrency['languageIsoCode'] = "es";
      return newCurrency;
    }
  }
}
